const dialogStyle = {
  wrapper: 'mx-auto opacity-100',
  title: 'relative text-4xl font-bold h-8vh',
  closeButton: 'absolute right-0 top-0 bottom-0 align-middle -mt-2 mr-4',
  closeButtonIcon: 'text-9xl text-white',
  content: 'h-90vh px-4',
  iframeWrapper: 'h-90vh',
};

export default {
  simpleButton: {
    buttonWrapper: '',
    button: 'btn btn-solid',
    text: '',
    icon: '',
    dialog: dialogStyle,
  },
  imageButton: {
    buttonWrapper: '',
    imageContainer: 'relative event_video_play cursor-pointer',
    image: 'max-w-full',
    icon:
      'icon-video text-white text-60 absolute -translate-xy50 pin-t50 pin-l50',
    dialog: dialogStyle,
  },
  iconButtonBlack: {
    buttonWrapper: '',
    button: 'icon-button text-black flex items-center',
    text:
      'icon-button-text font-sans-bold text-s13-m13-l15 text-black py-2 lg:py-3 pl-10',
    icon: 'text-s30-m30-l45',
    dialog: dialogStyle,
  },
  iconButtonBlackCenter: {
    buttonWrapper: '',
    button: 'icon-button text-black flex items-center mx-auto',
    text:
      'icon-button-text font-sans-bold text-s13-m13-l15 text-black py-2 lg:py-3 pl-10',
    icon: 'text-s30-m30-l45',
    dialog: dialogStyle,
  },
  iconButtonWhite: {
    buttonWrapper: '',
    button: 'icon-button text-black md:text-white flex items-center',
    text:
      'icon-button-text font-sans-bold text-s13-m13-l15 text-black md:text-white py-2 lg:py-3 pl-10',
    icon: 'text-s30-m30-l45',
    dialog: dialogStyle,
  },
  iconButtonWhiteCenter: {
    buttonWrapper: '',
    button: 'icon-button text-black md:text-white flex items-center mx-auto',
    text:
      'icon-button-text font-sans-bold text-s13-m13-l15 text-black md:text-white py-2 lg:py-3 pl-10',
    icon: 'text-s30-m30-l45',
    dialog: dialogStyle,
  },
  simpleButton_ln: {
    buttonWrapper: '',
    button: 'btn btn-amber',
    text: '',
    icon: '',
    dialog: dialogStyle,
  },
  'imageButton-center-losandes': {
    buttonWrapper: '',
    imageContainer:
      'absolute top-0 bottom-0 left-0 right-0 m-auto h-16 event_video_play cursor-pointer',
    image: 'max-w-full',
    icon: ' text-white text-60 absolute -translate-xy50 pin-t50 pin-l50',
    dialog: dialogStyle,
  },
};
